import { createContext, useContext, useMemo } from "react";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";
import { isFigmaCapture } from '../../utils/figmaCapture';

const CaseStudyChromeContext = createContext(null);

export function useCaseStudyChrome() {
  return useContext(CaseStudyChromeContext);
}


export function CaseStudyChromeProvider({ study, children }) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const motionEnabled =
    Boolean(study?.motion) && !prefersReducedMotion && !isFigmaCapture;

  const value = useMemo(
    () => (motionEnabled ? { motionEnabled } : null),
    [motionEnabled],
  );

  return (
    <CaseStudyChromeContext.Provider value={value}>
      {children}
    </CaseStudyChromeContext.Provider>
  );
}

CaseStudyChromeContext.displayName = "CaseStudyChromeContext";
